/* eslint-disable no-lone-blocks */
import axios from 'axios'
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {stopLoading} from '../../../../Redux/FrontEnd/Loading/LoadingSlice'
import {ENV} from '../../../../Utils/_helpers/EnvHelper'

const API_URL = ENV().REACT_APP_API_URL
const initialState: any = {
  users: {},
}

export const fetchAllUser: any = createAsyncThunk(
  '/GetUserAccountSmartSms',
  async (data: any, thunkApi) => {
    const response: any = await axios.get(`${API_URL}smart-sms/user`, {
      params: data,
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })

    thunkApi.dispatch(stopLoading())

    return response.data
  }
)

const UserSmartSMS = createSlice({
  name: 'UserAccountSmartSms',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchAllUser.fulfilled]: (state, {payload}) => {
      return {...state, users: payload?.data}
    },
  },
})

export const getAllUser = (state: any) => state?.UserAccountSmartSms?.users

export const getUserSmartSMS = (state: any) => state?.UserAccountSmartSms

export default UserSmartSMS.reducer
